module.exports = __webpack_public_path__ + "static/media/address-icon.0efb68c6.svg";